import _defineProperty from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/defineProperty";
import Binary from '../../binary/Binary'; //var config = require('../../../config')

import readProp from './readProp';

function readSingle(bitStream, protocolResolver, config) {
  var _ref;

  var id = bitStream[Binary[config.ID_BINARY_TYPE].read]();
  var protocol = protocolResolver(id);
  var propKey = bitStream[Binary[protocol.keyType].read]();
  var prop = protocol.keys[propKey];
  var propData = protocol.properties[prop];
  var value = readProp(bitStream, propData.type, propData.arrayIndexType); //bitStream[Binary[propData.type].read]()

  return _ref = {}, _defineProperty(_ref, config.ID_PROPERTY_NAME, id), _defineProperty(_ref, "prop", prop), _defineProperty(_ref, "path", propData.path), _defineProperty(_ref, "value", value), _ref;
}

export default readSingle;